<div class="modal-header">
  <h5 class="modal-title flex-grow-1">{{ title() }}</h5>
  @if (showNavigation()) {
    <div class="d-flex align-items-center gap-3 me-3" data-testid="modal-navigation">
      <button
        type="button"
        class="p-0 border-0 bg-transparent"
        data-testid="previous-button"
        [class.text-muted]="isFirst()"
        [disabled]="isFirst()"
        (click)="previous.emit()"
      >&lsaquo; Previous</button>
      <button
        type="button"
        class="p-0 border-0 bg-transparent"
        data-testid="next-button"
        [class.text-muted]="isLast()"
        [disabled]="isLast()"
        (click)="next.emit()"
      >Next &rsaquo;</button>
    </div>
  }
  <button type="button" class="btn-close" aria-label="Close" (click)="closed.emit()"></button>
</div>
